import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
import { readClickGeometry } from "../utils/ClickGeometry";
class ClickBehavior extends Behavior {
    constructor(plasm, appName, addMetadata, clickTargets) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.click;
        this.clickTargets = clickTargets !== null && clickTargets !== void 0 ? clickTargets : [];
        this.handler = (event) => this.onClick(event);
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
    onClick(event) {
        const geometry = readClickGeometry(event, this.clickTargets);
        this.addLog(event, this.id, geometry != null ? { extraData: geometry } : null);
    }
}
export default ClickBehavior;
